<template>
	<div class="docmix">
		<slot name="header"></slot>
		<slot name="info"></slot>
		<slot name="example"></slot>
		<slot name="code"></slot>
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'bsf-docmix',
		components: {},
		props: {},
		data() {
			return {}
		},
		mounted: function() {
			this.$nextTick(function() {})
		},
		computed: {}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.doc{
	}
	.docmix {
		.mgb;
	}
	
	.col-xs-9 {
		.doc:nth-child(odd) {
			background-color:rgb(250,250,250);
		}
		.docmix {
			.mgb(2*@mpb);
		}
	}
</style>


// WEBPACK FOOTER //
// docmix.vue?3bf08d41